import Header from './Header';

function Ojisan() {
    return (
        <div>
            <div className="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <div className="box">
                    <img src={`${process.env.PUBLIC_URL}/noimage.png`} />
                    <h1>OjisanBot</h1>
                    <p>送信した文章をおじさん構文に変換するDiscordBot。あらかじめ登録された語彙をもとに、おじさんっぽい文章を生成します。</p>
                    <div className="items">
                        <p><span>Python</span><span>discord.py</span><span>janome</span><span>ubuntu server</span></p>
                    </div>
                </div>
                <div className="box">
                    <p>おじさんとお話したい方はこちらの<a href="https://discord.gg/gZbK29aggb">Discordサーバー</a>へお気軽にどうぞ。</p>
                </div>
            </div>
        </div>
    )
}

export default Ojisan;